/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Extend Warehouse predictive search to all product fields supported by Shopify.
 * Scoped to the native predictive-search section request only.
 */
(function () {
  var nativeFetch = window.fetch.bind(window);

  var predictiveSearchFields =
    'title,body,tag,product_type,variants.title,variants.sku,variants.barcode,vendor';

  function expandDgaSearchQuery(value) {
    var query = (value || '').trim();

    /* Catalog-specific alias: 285 is an internal fragment of CE285A. */
    if (query.toUpperCase() === '285') {
      return '285 OR 85A';
    }

    if (/\sAND\s285$/i.test(query)) {
      return query.replace(/\sAND\s285$/i, ' AND (285 OR 85A)');
    }

    return query;
  }

  function hasMinimumPredictiveCharacters(value) {
    var usefulCharacters = (value || '').match(
      /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/g
    );

    return usefulCharacters !== null && usefulCharacters.length >= 2;
  }

  function getPredictiveSearchInput() {
    var activeElement = document.activeElement;

    if (
      activeElement &&
      activeElement.matches &&
      activeElement.matches(
        '.header__search-bar-wrapper input[name="q"]'
      )
    ) {
      return activeElement;
    }

    return document.querySelector(
      '.header__search-bar-wrapper input[name="q"]'
    );
  }

  function hidePredictiveSearch(input) {
    var wrapper =
      input && input.closest
        ? input.closest('.header__search-bar-wrapper')
        : document.querySelector('.header__search-bar-wrapper');

    if (!wrapper) {
      return;
    }

    var searchBar = wrapper.querySelector('.search-bar');
    var results = wrapper.querySelector('.search-bar__results');
    var resultsInner = wrapper.querySelector(
      '.search-bar__results-inner'
    );
    var menu = wrapper.querySelector('.search-bar__menu-wrapper');

    if (searchBar) {
      searchBar.classList.remove('is-expanded', 'is-loading');
    }

    if (results) {
      results.setAttribute('aria-hidden', 'true');
    }

    if (resultsInner) {
      resultsInner.innerHTML = '';
    }

    if (menu) {
      menu.setAttribute('aria-hidden', 'true');
    }
  }

  function createEmptyPredictiveResponse() {
    return new Response('<section class="search-ajax"></section>', {
      status: 200,
      headers: {
        'Content-Type': 'text/html; charset=utf-8'
      }
    });
  }

  function hideShortPredictiveSearch(event) {
    var input = event.target;

    if (
      !input ||
      !input.matches ||
      !input.matches(
        '.header__search-bar-wrapper input[name="q"]'
      ) ||
      hasMinimumPredictiveCharacters(input.value)
    ) {
      return;
    }

    hidePredictiveSearch(input);
  }

  document.addEventListener('input', hideShortPredictiveSearch, true);
  document.addEventListener('focusin', hideShortPredictiveSearch);

  window.fetch = function (resource, options) {
    if (typeof resource === 'string') {
      try {
        var url = new URL(resource, window.location.origin);

        if (
          url.origin === window.location.origin &&
          /\/search\/suggest$/.test(url.pathname) &&
          url.searchParams.get('section_id') === 'predictive-search'
        ) {
          var predictiveInput = getPredictiveSearchInput();
          var predictiveValue = predictiveInput
            ? predictiveInput.value
            : (url.searchParams.get('q') || '')
                .split(/\s+AND\s+/i)
                .pop();

          if (!hasMinimumPredictiveCharacters(predictiveValue)) {
            hidePredictiveSearch(predictiveInput);

            return Promise.resolve(createEmptyPredictiveResponse());
          }

          url.searchParams.set(
            'q',
            expandDgaSearchQuery(url.searchParams.get('q'))
          );

          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');

          url.searchParams.set(
            'resources[options][fields]',
            predictiveSearchFields
          );

          resource = url.pathname + url.search + url.hash;
        }
      } catch (error) {
        // Preserve the original request if an unexpected URL is received.
      }
    }

    return nativeFetch(resource, options);
  };

  /* Keep the visible input untouched while typing, and expand only at submit. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (
        !form ||
        !form.matches ||
        !form.matches('form.search-bar, form.empty-state__quick-form')
      ) {
        return;
      }

      var input = form.querySelector('input[name="q"]');

      if (!input) {
        return;
      }

      input.value = expandDgaSearchQuery(input.value);
    },
    true
  );
})();

/* =========================================================
   DGA - CORRECCION AUTOPLAY DEL CARRUSEL PRINCIPAL

   Objetivo:
   - Mantener el carrusel superior rotando automaticamente.
   - Cambiar de slide cada 3 segundos.
   - Evitar que se quede detenido por hover o por una
     inicializacion incompleta del tema.
   ========================================================= */

(function () {
  'use strict';

  var DGA_SLIDESHOW_INTERVAL = 3000;
  var retryTimer = null;
  var retryCount = 0;
  var maxRetries = 30;

  function getDgaSlideshow() {
    return document.querySelector(
      '[data-section-type="slideshow"] .slideshow'
    );
  }

  function startDgaSlideshowAutoplay() {
    var slider = getDgaSlideshow();

    if (!slider || !window.Flickity) {
      return false;
    }

    var flkty = window.Flickity.data(slider);

    if (!flkty) {
      return false;
    }

    flkty.options.autoPlay = DGA_SLIDESHOW_INTERVAL;
    flkty.options.pauseAutoPlayOnHover = false;

    if (typeof flkty.stopPlayer === 'function') {
      flkty.stopPlayer();
    }

    if (typeof flkty.playPlayer === 'function') {
      flkty.playPlayer();
      return true;
    }

    return false;
  }

  function ensureDgaSlideshowAutoplay() {
    if (startDgaSlideshowAutoplay()) {
      if (retryTimer) {
        clearInterval(retryTimer);
        retryTimer = null;
      }

      return;
    }

    if (!retryTimer) {
      retryCount = 0;

      retryTimer = setInterval(function () {
        retryCount += 1;

        if (
          startDgaSlideshowAutoplay() ||
          retryCount >= maxRetries
        ) {
          clearInterval(retryTimer);
          retryTimer = null;
        }
      }, 500);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureDgaSlideshowAutoplay();
  });

  window.addEventListener('load', function () {
    ensureDgaSlideshowAutoplay();
  });

  window.addEventListener('pageshow', function () {
    ensureDgaSlideshowAutoplay();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.target &&
      event.target.querySelector &&
      event.target.querySelector('.slideshow')
    ) {
      ensureDgaSlideshowAutoplay();
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      ensureDgaSlideshowAutoplay();
    }
  });
})();
